import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Link } from '@material-ui/core';

import { Body2Text, CaptionText } from '../../TextVariants';
import { colors } from '../../../theme';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: theme.spacing(11.25),
    width: '100%',
    borderTop: '1px solid #EAEAEA',
    padding: '12px 25px',
  },
  link: {
    color: 'inherit',
    textDecorationLine: 'underline',
  },
}));

export type FooterProps = {
  IsMobile?: boolean;
  textColor?: string;
  backgroundColor?: string;
  rootStyles?: React.CSSProperties;
  country?: string;
  linkText?: string;
  linkHref?: string;
};

const Footer = ({
  IsMobile = false,
  textColor = colors.light_silver,
  rootStyles,
  country,
  linkText,
  linkHref,
}: FooterProps): JSX.Element => {
  const classes = useStyles();
  const countryText = country || 'Panamá';
  const footerTextMobile: React.ReactNode =
    country === 'Costa Rica' ? (
      ''
    ) : (
      <>
        Regulado y Supervisado por la Superintendencia <br />
        de Seguros y Reaseguros de {countryText}
      </>
    );

  const footerTextNormal =
    country === 'Costa Rica'
      ? ''
      : 'Regulado y Supervisado por la Superintendencia de Seguros y Reaseguros de'.concat(
          ' ',
          countryText,
        );
  const href =
    linkHref === undefined
      ? 'https://www.assanet.com/privacidad-proteccion-de-datos/'
      : linkHref;
  return IsMobile ? (
    <div
      className={classes.root}
      data-testid="mobileFooterId"
      style={rootStyles}
    >
      <CaptionText
        style={{ color: textColor }}
        align="center"
        data-testid="caption-text1"
      >
        {footerTextMobile}
      </CaptionText>
      <CaptionText
        style={{ color: textColor }}
        align="center"
        data-testid="caption-text2"
      >
        © Copyright - ASSA Compañía de Seguros |{' '}
        <Link
          href={href}
          target="_blank"
          className={classes.link}
          data-testid="linkId"
        >
          {linkText || 'Términos y Condiciones'}
        </Link>
      </CaptionText>
    </div>
  ) : (
    <div
      className={classes.root}
      data-testid="desktopFooterId"
      style={rootStyles}
    >
      <Body2Text
        style={{ color: textColor }}
        align="center"
        data-testid="body-text1"
      >
        {footerTextNormal}
      </Body2Text>
      <Body2Text
        style={{ color: textColor }}
        align="center"
        data-testid="body-text2"
      >
        © Copyright - ASSA Compañía de Seguros |{' '}
        <Link
          href={href}
          target="_blank"
          className={classes.link}
          data-testid="linkId"
        >
          {linkText || 'Términos y Condiciones'}
        </Link>
      </Body2Text>
    </div>
  );
};

export default Footer;
